import BaseModel from "./base/baseModel";

export default class ValidadeFormaFarmaceuticaProdutoModel extends BaseModel {
    formaFarmaceuticaId?: number = 0;
    formaFarmaceuticaDescricao?: string = null;
    produtoId?: number = 0;
    diasValidade = 0;
}